import {goAnchor} from './goAnchor.js'
const tool = {
    goAnchor: goAnchor
}

export default tool;